<template>
  <v-container grid-list-lg class="pa-0 ma-0" fluid>
    <v-layout row wrap>
      <v-flex xs12 sm12 md12 lg12 class="pt-0 pb-0">
        <v-card flat :style="!$vuetify.breakpoint.smAndDown ? 'padding-left: 114px; padding-right: 114px;' : 'padding-top: 15px; padding-bottom: 10px;'">
          <v-card-title class="pt-0 pb-0">
            <v-layout row wrap :align-center="$vuetify.breakpoint.smAndUp" :align-content-center="$vuetify.breakpoint.smAndDown">
            
              <v-flex xs12 sm3 md2 lg1 :style="filtroComputed.filtroDataString() == 'Datas' ? !$vuetify.breakpoint.smAndDown ? 'margin-right: 10px;' : '' : !$vuetify.breakpoint.smAndDown ? 'margin-right: 55px;' : ''">
                <v-menu
                  v-model="filtro.data.opened"
                  :close-on-content-click="false"
                  offset-y
                  transition="slide-y-transition"
                  :full-width="$vuetify.breakpoint.smAndDown"
                >
                  <v-btn
                    color="primary"
                    round
                    :outline="filtroComputed.filtroDataString() == 'Datas'"
                    slot="activator"
                    :block="$vuetify.breakpoint.smAndDown"
                  >{{filtroComputed.filtroDataString()}}</v-btn>
                  <v-card>
                    <v-layout row wrap >
                      <v-flex xs5 class="ma-3 text-xs-center">
                        <b><span class="primary--text">Data Inicial</span></b>
                        <br><br>
                        <v-date-picker
                          id="filtroDataInicioDatePicker"
                          v-model="filtro.data.dataInicio"
                          header-color="primary"
                          locale="pt-br"
                          :max="(new Date()).toISOString().substring(0, 10)"
                        ></v-date-picker>
                      </v-flex>
                      <v-flex xs5 class="ma-3 text-xs-center">
                        <b><span class="primary--text">Data Final</span></b>
                        <br><br>
                        <v-date-picker
                          id="filtroDataFimDatePicker"
                          v-model="filtro.data.dataFim"
                          header-color="primary"
                          locale="pt-br"
                          :max="(new Date()).toISOString().substring(0, 10)"
                        ></v-date-picker>
                      </v-flex>
                    </v-layout>
                    <v-card-actions>
                      <v-layout>
                        <v-btn
                          @click="filtroFunctions().limparDatas()"
                          color="primary"
                          flat
                          small
                        >Limpar</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn
                          @click="filtroFunctions().aplicarDatas()"
                          color="primary"
                          flat
                          small
                        >Aplicar</v-btn>
                      </v-layout>
                    </v-card-actions>
                  </v-card>
                </v-menu>
              </v-flex>

              <v-flex xs12 sm3 md2 lg1 v-if="getPermissao('ANALISA_SOLICITACAO')"
                :style="filtroComputed.filtroContaString().length < 12 ? !$vuetify.breakpoint.smAndDown ? 'margin-right: 10px;' : '' : !$vuetify.breakpoint.smAndDown ? 'margin-right: 75px;' : ''"
              >
                <v-menu
                  v-model="filtro.contas.opened"
                  :close-on-content-click="false"
                  offset-y
                  transition="slide-y-transition"
                  :full-width="$vuetify.breakpoint.smAndDown"
                >
                  <v-btn
                    color="primary"
                    round
                    :outline="filtroComputed.filtroContaString() == 'Contas'"
                    slot="activator"
                    :block="$vuetify.breakpoint.smAndDown"
                  >{{filtroComputed.filtroContaString()}}</v-btn>
                  <v-card max-width="200px">
                    <v-layout row wrap class="pb-0 pa-3">
                      <v-flex xs12 v-for="conta in filtro.contas.opcoes" :key="conta">
                        <v-btn
                          @click="filtroFunctions().selecionarConta(conta)"
                          :color="filtroComputed.contaSelecionadaDescricaoString() == conta ? 'primary' : 'themeGrey'"
                          round
                          block
                          :outline="filtroComputed.contaSelecionadaDescricaoString() != conta"
                        >{{conta}}</v-btn>
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-menu>
              </v-flex>

              <v-flex xs12 sm3 md2 lg1 v-if="getPermissao('ANALISA_SOLICITACAO')"
                :style="filtroComputed.filtrotipoSolicitacaoString().length < 10 ? !$vuetify.breakpoint.smAndDown ? 'margin-right: 11px;' : '' : !$vuetify.breakpoint.smAndDown ? `margin-right: ${(filtroComputed.filtrotipoSolicitacaoString().length/2.3) }%;` : ''"
              >
                <v-menu
                  v-model="filtro.tipoSolicitacao.opened"
                  :close-on-content-click="false"
                  offset-y
                  transition="slide-y-transition"
                  :full-width="$vuetify.breakpoint.smAndDown"
                >
                  <v-btn
                    color="primary"
                    round
                    :outline="filtroComputed.filtrotipoSolicitacaoString() == 'Tipo'"
                    slot="activator"
                    :block="$vuetify.breakpoint.smAndDown"
                  >{{filtroComputed.filtrotipoSolicitacaoString()}}</v-btn>
                  <v-card max-width="200px">
                    <v-layout row wrap class="pb-0 pa-3">
                      <v-flex xs12 v-for="tipoSolicitacao in filtro.tipoSolicitacao.opcoes" :key="tipoSolicitacao">
                        <v-btn
                          @click="filtroFunctions().selecionartipoSolicitacao(tipoSolicitacao)"
                          :color="filtroComputed.tipoSolicitacaoSelecionadoDescricaoString() == tipoSolicitacao ? 'primary' : 'themeGrey'"
                          round
                          block
                          :outline="filtroComputed.tipoSolicitacaoSelecionadoDescricaoString() != tipoSolicitacao"
                        >{{tipoSolicitacao}}</v-btn>
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-menu>
              </v-flex>

              <v-flex xs12 sm3 md2 lg1 v-if="getPermissao('ANALISA_SOLICITACAO')" :style="filtroComputed.filtroValorPremioString() == 'Valor do Prêmio' ? !$vuetify.breakpoint.smAndDown ? 'margin-right: 68px;' : '' : !$vuetify.breakpoint.smAndDown ? `margin-right: ${(filtroComputed.filtroValorPremioString().length*4.5) }px;` : ''">
                <v-menu
                  v-model="filtro.valorPremio.opened"
                  :close-on-content-click="false"
                  offset-y
                  transition="slide-y-transition"
                  :full-width="$vuetify.breakpoint.smAndDown"
                >
                  <v-btn
                    color="primary"
                    round
                    :outline="filtroComputed.filtroValorPremioString() == 'Valor do Prêmio'"
                    slot="activator"
                    :block="$vuetify.breakpoint.smAndDown"
                  >{{filtroComputed.filtroValorPremioString()}}</v-btn>
                  <v-card>
                    <v-layout row wrap >
                      <v-flex xs5 class="ma-3 text-xs-center">
                        <v-text-field
                          id="filtroPremioValorMin"
                          ref="filtroPremioValorMin"
                          v-model="filtro.valorPremio.valorMin"
                          v-money="maskComputed.maskMoney"
                          label="Valor Mínimo"
                          hint="Informe o valor mínimo"
                          color="primary"
                          :rules="functionsComputed.regras.valorPremioMin(filtro.valorPremio.valorMin, filtro.valorPremio.valorMax)"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs5 class="ma-3 text-xs-center">
                        <v-text-field
                          id="filtroPremioValorMax"
                          ref="filtroPremioValorMax"
                          v-model="filtro.valorPremio.valorMax"
                          v-money="maskComputed.maskMoney"
                          label="Valor Máximo"
                          hint="Informe o valor máximo"
                          color="primary"
                          :rules="functionsComputed.regras.valorPremioMax(filtro.valorPremio.valorMin, filtro.valorPremio.valorMax)"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                    <v-card-actions>
                      <v-layout>
                        <v-btn
                          @click="filtroFunctions().limparValorPremio()"
                          color="primary"
                          flat
                          small
                        >Limpar</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn
                          @click="filtroFunctions().aplicarValorPremio()"
                          color="primary"
                          flat
                          small
                        >Aplicar</v-btn>
                      </v-layout>
                    </v-card-actions>
                  </v-card>
                </v-menu>
              </v-flex>

              <v-flex xs12 sm11 md6 lg4>
                <transition name="fade">
                  <v-flex xs1 v-if="!filtro.pesquisa.opened">
                    <v-btn
                      v-if="!filtro.pesquisa.opened"
                      @click="filtroFunctions().abrirFiltroPesquisa()"
                      color="primary"
                      round
                      outline
                      v-on="on"
                      icon
                    ><v-icon>search</v-icon></v-btn>
                  </v-flex>
                  <v-flex v-else>
                    <v-text-field
                      v-model="filtro.pesquisa.conteudo"
                      prepend-icon="search"
                      @click:prepend="filtroFunctions().fecharFiltroPesquisa()"
                      @blur="filtroFunctions().fecharFiltroPesquisa()"
                      label="Busca"
                      hint="Informe cliente ou nº da solicitação"
                      autofocus
                      clearable
                    ></v-text-field>
                  </v-flex>
                </transition>
              </v-flex>
            
            </v-layout>
          </v-card-title>
        </v-card>
      </v-flex>
    </v-layout>
    
    <v-container class="ml-82 mr-82 mt-3 pa-24">
      <v-layout row wrap>
        <v-flex xs12>
          <h4
            class="themeGrey--text"
            v-if="solicitacao.listas.filtrada.length == 0"
          >Nenhuma solicitação foi encontrada</h4>
          <template>
            <v-expansion-panel expand popout>
              
              <v-expansion-panel-content
                v-for="status in statusLista"
                :id="'status-' + status.id"
                :key="status.id"
              >
                <v-divider></v-divider>
                <div slot="header">
                  <template v-if="!$vuetify.breakpoint.smAndDown">
                    <v-layout
                      :align-center="$vuetify.breakpoint.smAndUp"
                      :align-content-center="$vuetify.breakpoint.smAndDown"
                    >
                      <v-flex>
                        
                        <v-tooltip
                          left
                          v-if="getSolicitacaoEmAtraso(getSolicitacoesDoStatus(status.id)) && getPermissao('ANALISA_SOLICITACAO')"
                        >
                          <v-badge slot="activator">
                            <v-icon
                              :id="'icone-status-' + status.id + '-em-atraso'"
                              color="red"
                            >error</v-icon>
                          </v-badge>
                          <span>Em atraso</span>
                        </v-tooltip>
                        <v-icon
                          :id="'icone-status-' + status.id"
                          v-else
                          color="rgba(0, 0, 0, 0.2)"
                        >
                          {{ getPermissao('ANALISA_SOLICITACAO') ?
                          status.icone :
                          status.iconeCliente }}
                        </v-icon>
                      </v-flex>
                      <v-flex style="min-width: 44px;">
                        <v-tooltip
                        left v-if="verificarNotificaoPendente(getSolicitacoesDoStatus(status.id)) && getPermissao('ANALISA_SOLICITACAO')">
                        <v-badge slot="activator">
                          <v-icon color="#336A8B">circle_notifications</v-icon>
                        </v-badge>
                          <span>Notificação pendente</span>
                        </v-tooltip>
                      </v-flex>
                      <v-flex xs4>
                        <h4
                          :id="'status-' + status.id + '-titulo'"
                          class="themeGrey--text"
                        >
                          {{ getPermissao('ANALISA_SOLICITACAO') ?
                          status.statusNoPlural :
                          status.statusClienteNoPlural }}
                        </h4>
                      </v-flex>
                      <v-spacer></v-spacer>
                      <v-flex xs4>
                        <span
                          :id="'status-' + status.id + '-numero-solicitacoes'"
                          class="themeGrey--text"
                        >
                          {{ getSolicitacoesDoStatus(status.id).length > 1 ?
                          getSolicitacoesDoStatus(status.id).length + ' Solicitações' :
                          getSolicitacoesDoStatus(status.id).length + ' Solicitação'}}
                        </span>
                      </v-flex>
                      <v-spacer></v-spacer>
                      <v-flex xs4>
                        <span
                          :id="'status-' + status.id + '-solicitacao-mais-recente'"
                          class="themeGrey--text"
                        >Última Solicitação: {{ getDataSolicitacaoMaisRecente(getSolicitacoesDoStatus(status.id)) }}</span>
                      </v-flex>
                    </v-layout>
                  </template>
                  <template v-else>
                    <v-layout
                      :align-center="$vuetify.breakpoint.smAndUp"
                      :align-content-center="$vuetify.breakpoint.smAndDown"
                      row
                      wrap
                    >
                      <v-flex shrink>
                        
                        <v-tooltip
                          left
                          v-if="getSolicitacaoEmAtraso(getSolicitacoesDoStatus(status.id)) && getPermissao('ANALISA_SOLICITACAO')"
                        >
                          <v-badge slot="activator">
                            <v-icon
                              :id="'icone-status-' + status.id + '-em-atraso'"
                              color="red"
                            >error</v-icon>
                          </v-badge>
                          <span>Em atraso</span>
                        </v-tooltip>
                        <v-icon
                          :id="'icone-status-' + status.id"
                          v-else
                          color="rgba(0, 0, 0, 0.2)"
                        >
                          {{ getPermissao('ANALISA_SOLICITACAO') ?
                          status.icone :
                          status.iconeCliente }}
                        </v-icon>
                      </v-flex>
                      <v-flex shrink>
                        <v-tooltip
                        left v-if="verificarNotificaoPendente(getSolicitacoesDoStatus(status.id)) && getPermissao('ANALISA_SOLICITACAO')">
                        <v-badge slot="activator">
                          <v-icon color="#336A8B">circle_notifications</v-icon>
                        </v-badge>
                          <span>Notificação pendente</span>
                        </v-tooltip>
                      </v-flex>
                      <v-flex xs9>
                        <h4
                          :id="'status-' + status.id + '-titulo'"
                          class="themeGrey--text"
                        >
                          <div style="overflow: hidden; text-overflow: ellipsis">
                            {{ getPermissao('ANALISA_SOLICITACAO') ?
                            status.statusNoPlural :
                            status.statusClienteNoPlural }}
                          </div>
                        </h4>
                      </v-flex>
                      <v-flex xs12 ml-5>
                        <span
                          :id="'status-' + status.id + '-numero-solicitacoes'"
                          class="themeGrey--text"
                        >
                          {{ getSolicitacoesDoStatus(status.id).length > 1 ?
                          getSolicitacoesDoStatus(status.id).length + ' Solicitações' :
                          getSolicitacoesDoStatus(status.id).length + ' Solicitação'}}
                        </span>
                      </v-flex>
                      <v-flex xs12 ml-5>
                        <span
                          :id="'status-' + status.id + '-solicitacao-mais-recente'"
                          class="themeGrey--text"
                        >
                          Última Solicitação:
                          <br>
                          {{ getDataSolicitacaoMaisRecente(getSolicitacoesDoStatus(status.id)) }}
                        </span>
                      </v-flex>
                    </v-layout>
                  </template>
                </div>
                <v-list two-line>
                  <v-list-tile
                    v-for="solicitacao in getSolicitacoesDoStatus(status.id)"
                    :id="'solicitacao-' + solicitacao.protocolo"
                    :key="solicitacao.id"
                    avatar
                    @click="abrirSolicitacao(solicitacao)"
                  >
                    <v-list-tile-avatar>
                      <v-tooltip
                        left
                        v-if="solicitacao.emAtraso && getPermissao('ANALISA_SOLICITACAO')"
                      >
                        <v-badge slot="activator" overlap color="red">
                          <v-icon
                            v-if="!solicitacao.grandeCotacao || !getPermissao('ANALISA_SOLICITACAO')"
                            :id="'solicitacao-' + solicitacao.protocolo + '-icone-em-atraso'"
                            large
                            class="solicitacao-prata"
                          >description</v-icon>
                          <v-icon
                            v-else
                            :id="'solicitacao-' + solicitacao.protocolo + '-icone-em-atraso'"
                            large
                            class="solicitacao-dourada"
                          >description</v-icon>
                          <span slot="badge">!</span>
                        </v-badge>
                        <span>Em atraso</span>
                      </v-tooltip>
                      <div v-else>
                        <v-icon
                          v-if="!solicitacao.grandeCotacao || !getPermissao('ANALISA_SOLICITACAO')"
                          :id="'solicitacao-' + solicitacao.protocolo + '-icone'"
                          large
                          class="solicitacao-prata"
                        >description</v-icon>
                        <v-icon
                          v-else
                          :id="'solicitacao-' + solicitacao.protocolo + '-icone'"
                          large
                          class="solicitacao-dourada"
                        >description</v-icon>
                      </div>
                    </v-list-tile-avatar>
                    <v-list-tile-content>
                      <template v-if="!$vuetify.breakpoint.smAndDown">
                        <v-list-tile-title
                          :id="'solicitacao-' + solicitacao.protocolo + '-protocolo-empresa'"
                        >{{solicitacao.protocolo}} &mdash; {{ solicitacao.proponente }}</v-list-tile-title>
                        <v-list-tile-sub-title
                          :id="'solicitacao-' + solicitacao.protocolo + '-data'"
                        >
                          <span v-if="getPermissao('ANALISA_SOLICITACAO')">
                            <span class="primary--text">{{`${solicitacao.premioTotal > 0 ? customFormatComputed.toMoneyString(solicitacao.premioTotal) : 'R$ 0'}` }}</span>
                            {{` - `}}
                          </span>
                          <span>{{ `${solicitacao.dataCriacao.toLocaleString('pt-br')}` }}</span>
                          <span
                            :id="'solicitacao-' + solicitacao.protocolo + '-ambiente-insercao'"
                            v-if="getPermissao('VISUALIZA_SOLICITACAO_TIPO_CLIENTE')"
                          >{{ ` - ${solicitacao.tipoSolicitacao}` }}</span>
                          <span
                            :id="'solicitacao-' + solicitacao.protocolo + '-tipo-cliente'"
                          >{{ ` - ${solicitacao.tipoCliente}` }}</span>
                        </v-list-tile-sub-title>
                      </template>
                      <template v-else>
                        <v-list-tile-title
                          :id="'solicitacao-' + solicitacao.protocolo + '-protocolo'"
                        >{{solicitacao.protocolo}}</v-list-tile-title>
                        <v-list-tile-title
                          :id="'solicitacao-' + solicitacao.protocolo + '-empresa'"
                          class="text--primary"
                        >{{ solicitacao.proponente }}</v-list-tile-title>
                        <v-list-tile-sub-title
                          :id="'solicitacao-' + solicitacao.protocolo + '-data'"
                        >{{ solicitacao.dataCriacao.toLocaleString('pt-br') }}</v-list-tile-sub-title>
                      </template>
                    </v-list-tile-content>
                    <v-list-tile-action>
                      <v-flex >

                        <v-list-tile-action-text class="body-1 flex-custom">
                            <v-toolbar class="elevation-0" color="transparent">
                              <v-tooltip v-if="solicitacao.notificacaoPendente" right >
                                <v-badge  slot="activator">
                                  <v-icon style="width: 0;" class="icone-notificao-pendente" color="#336A8B">mark_email_unread</v-icon>
                                </v-badge>
                                <span>Novas tratativas</span>
                              </v-tooltip>
                              <v-icon
                                medium
                                :color="getPermissao('ANALISA_SOLICITACAO') ?
                                              status.corIcone :
                                              status.corIconeCliente"
                              >
                                {{ getPermissao('ANALISA_SOLICITACAO') ?
                                status.icone :
                                status.iconeCliente }}
                              </v-icon>
                              <span
                                :style="`color: ${ getPermissao('ANALISA_SOLICITACAO') ?
                                              status.corIcone :
                                              status.corIconeCliente}`"
                                class="pa-1 hidden-sm-and-down"
                              >
                                {{ getPermissao('ANALISA_SOLICITACAO') ?
                                status.descricao :
                                status.statuscliente }}
                              </span>
                            </v-toolbar>
                          
                        </v-list-tile-action-text>
                      </v-flex>
                    </v-list-tile-action>
                  </v-list-tile>
                </v-list>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </template>
        </v-flex>
      </v-layout>
    </v-container>
  </v-container>
</template>

<script>
import axios from "axios";
import cipher from "@/helpers/cipher";
import CustomFormat from "@/helpers/custom-format";
import EStatus from "@/helpers/estatus.js";
import filtroHelper from "@/helpers/filtro";
import functions from "@/components/pages/listagem-solicitacoes/functions.js";
import mask from "@/helpers/mask";
import perfil from "@/helpers/perfil";
import permissoes from "@/helpers/permissoes.js";
import usuarioHelper from "@/helpers/usuario-logado";
import {VMoney} from 'v-money';

export default {
  name: "listagemsolicitacoes",
  directives: {
    money: VMoney
  },
  data: () => {
    return {
      on: null,
      mapaPermissoes: null,
      solicitacao: {
        listas: {
          original: [],
          filtrada: []
        },
        mapas: {
          agrupamento: null
        }
      },
      status: {
        lista: [],
        mapas: {
          statusCliente: null
        }
      },
      filtro: {
        contas: {
          opened: false,
          opcoes: ["Todas as Contas", "Pequenas Contas", "Grandes Contas"],
          selecionada: null
        },
        pesquisa: {
          opened: false,
          conteudo: ""
        },
        data: {
          telaNova: null,
          opened: false,
          dataInicio: null,
          dataFim: null,
          aplicado: {
            dataInicio: null,
            dataFim: null,
            formatado: {
              dataInicio: null,
              dataFim: null
            }
          }
        },
        valorPremio: {
          opened: false,
          valorMin: null,
          valorMax: null,
          aplicado: {
            valorMin: null,
            valorMax: null,
            formatado: {
              valorMin: null,
              valorMax: null
            }
          }
        },
        tipoSolicitacao: {
          opened: false,
          opcoes: ["Todos os Tipos", "Interna", "Externa", "Plataforma"],
          selecionado: null
        }
      }
    };
  },
  computed: {
    statusLista: function() {
      const self = this;
      if (self.status.lista) {
        return self.status.lista.filter(status => {
          if (self.status.mapas.statusCliente) {
            if (status.id == self.status.mapas.statusCliente.get(status.id)) {
              return self.getSolicitacoesDoStatus(self.status.mapas.statusCliente.get(status.id)).length > 0;
            }
          } else {
            return self.getSolicitacoesDoStatus(status.id).length > 0;
          }
        });
      }
      return [];
    },
    filtroComputed: function() {
      const self = this;
      return {
        filtroDataString: function() {
          if (self.filtro.data.aplicado.dataInicio || self.filtro.data.aplicado.dataFim) {
            if (self.filtro.data.aplicado.dataInicio && self.filtro.data.aplicado.dataFim) {
              return `${self.filtro.data.aplicado.formatado.dataInicio} - ${self.filtro.data.aplicado.formatado.dataFim}`;
            } else if (self.filtro.data.aplicado.dataInicio) {
              return `${self.filtro.data.aplicado.formatado.dataInicio} - Hoje`;
            } else if (self.filtro.data.aplicado.dataFim) {
              return `Todas - ${self.filtro.data.aplicado.formatado.dataFim}`;
            }
          } else {
            return 'Datas';
          }
        },
        filtroContaString: function() {
          if (self.filtro.contas.selecionada) {
            return self.filtro.contas.selecionada;
          } else {
            return 'Contas';
          }
        },
        contaSelecionadaDescricaoString: function() {
          if (self.filtro.contas.selecionada) {
            return self.filtro.contas.selecionada;
          } else {
            return '';
          }
        },
        filtroValorPremioString: function() {
          if (self.filtro.valorPremio.aplicado.valorMin || self.filtro.valorPremio.aplicado.valorMax) {
            if (self.filtro.valorPremio.aplicado.valorMin && self.filtro.valorPremio.aplicado.valorMax) {
              return `${self.filtro.valorPremio.aplicado.formatado.valorMin} - ${self.filtro.valorPremio.aplicado.formatado.valorMax}`;
            } else if (self.filtro.valorPremio.aplicado.valorMin) {
              return `Mín ${self.filtro.valorPremio.aplicado.formatado.valorMin}`;
            } else if (self.filtro.valorPremio.aplicado.valorMax) {
              return `Até ${self.filtro.valorPremio.aplicado.formatado.valorMax}`;
            }
          } else {
            return 'Valor do Prêmio';
          }
        },
        filtrotipoSolicitacaoString: function() {
          if (self.filtro.tipoSolicitacao.selecionado) {
            return self.filtro.tipoSolicitacao.selecionado;
          } else {
            return 'Tipo';
          }
        },
        tipoSolicitacaoSelecionadoDescricaoString: function() {
          if (self.filtro.tipoSolicitacao.selecionado) {
            return self.filtro.tipoSolicitacao.selecionado;
          } else {
            return '';
          }
        }
      }
    },
    customFormatComputed: function() {
      return CustomFormat;
    },
    functionsComputed: function() {
      return functions;
    },
    maskComputed: function() {
      return mask;
    },
    permissoesComputed: function() {
      return permissoes;
    },
    usuarioHelperComputed: function() {
      return usuarioHelper;
    }
  },
  watch: {
    "filtro.pesquisa.conteudo": function(val) {
      const self = this;
      self.filtroFunctions().aplicarFiltros();
      self.agruparSolicitacoes();
    },
    "filtro.data.aplicado.dataInicio": function(val) {
      const self = this;
      self.filtro.data.aplicado.formatado.dataInicio = CustomFormat.parseDateToFormatedStringWithMonthName(val);
    },
    "filtro.data.aplicado.dataFim": function(val) {
      const self = this;
      self.filtro.data.aplicado.formatado.dataFim = CustomFormat.parseDateToFormatedStringWithMonthName(val);
    }
  },
  mounted: async function() {
    this.$store.commit("startLoading");

    this.mapaPermissoes = permissoes.getMapaPermissoes();
    this.status.mapas.statusCliente = functions.getMapaStatusCliente(this.mapaPermissoes);
    await this.carregarSolicitacoes();
    await this.carregarStatus();
    this.agruparSolicitacoes();

    this.$store.commit("endLoading");
  },
  methods: {
    verificarNotificaoPendente(solicitacoes) {
      let pendente = false;
      solicitacoes.forEach(solicitacao => {
        if (solicitacao.notificacaoPendente == true) {
          pendente = true;
        }
      });
      return pendente;
    },
    carregarSolicitacoes: async function() {
      const self = this;
      
      self.$store.commit("startLoading");
      await axios.get(`${process.env.URL_QUESTIONARIOMS}/v1/carregaListaSolicitacoes`,
        {
          headers: { Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}` }
        }
      )
      .then(response => {
        self.solicitacao.listas.original = response.data;
        self.solicitacao.listas.filtrada = response.data;
      })
      .catch(error => {
        self.$store.commit("endLoading");
      });
    },
    carregarStatus: async function() {
      const self = this;

      self.$store.commit("startLoading");
      await axios.get(`${process.env.URL_QUESTIONARIOMS}/v1/buscaTodosStatusQuestionario`,
        {
          headers: { Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}` }
        }
      )
      .then(response => {
        self.status.lista = response.data.sort(function(a, b) {
          return a.ordem - b.ordem;
        });
      })
      .catch(error => {
        self.$store.commit("endLoading");
      });
    },
    agruparSolicitacoes: function() {
      const self = this;
      self.solicitacao.listas.filtrada
      .sort((a, b) => {
        if (self.getPermissao('ANALISA_SOLICITACAO')) {
          return a.emAtraso === b.emAtraso ? 0 : a.emAtraso ? -1 : 1;
        }
      })
      .sort((a, b) => {
        return (
          self.getStatusPorId(a.idStatusSolicitacao).ordem - self.getStatusPorId(b.idStatusSolicitacao).ordem
        );
      });
      self.solicitacao.mapas.agrupamento = functions.getMapaSolicitacoesAgrupadas(self.status.lista, self.status.mapas.statusCliente, self.mapaPermissoes);

      self.solicitacao.listas.filtrada.forEach(solicitacao => {
        self.solicitacao.mapas.agrupamento.get(functions.getIdStatusAdequado(solicitacao.idStatusSolicitacao, self.status.mapas.statusCliente, self.mapaPermissoes)).push(solicitacao);
        self.solicitacao.mapas.agrupamento.get(functions.getIdStatusAdequado(solicitacao.idStatusSolicitacao, self.status.mapas.statusCliente, self.mapaPermissoes))
        .sort((a, b) => {
          if (self.getPermissao('ANALISA_SOLICITACAO')) {
            return a.emAtraso === b.emAtraso ? 0 : a.emAtraso ? -1 : 1;
          }
        })
        .sort((a, b) => {
          return b.dataCriacaoUnformatted.localeCompare(a.dataCriacaoUnformatted);
        });
      });
    },
    abrirSolicitacao: function(solicitacao) {
      if(solicitacao.telaNova == true){ 
        this.$router.push(`/QuestionarioAnaliseRiscos?id=${solicitacao.id}`);
      } else {
        this.$router.push({
          name: "SolicitacaoConsulta",
          params: { id: cipher.encrypt(solicitacao.id) }
          });
      }
    },
    getStatusPorId: function(idStatus) {
      const self = this;
      if (idStatus && self.status.lista) {
        return self.status.lista.find(status => {
          return status.id == idStatus;
        });
      }
    },
    getSolicitacaoEmAtraso: function(solicitacoes) {
      let emAtraso = false;
      solicitacoes.forEach(solicitacao => {
        if (solicitacao.emAtraso == true) {
          emAtraso = true;
        }
      });
      return emAtraso;
    },
    getDataSolicitacaoMaisRecente: function(solicitacoes) {
      let recente = null;
      solicitacoes.forEach(solicitacao => {
        if (recente == null) {
          recente = solicitacao.dataCriacao;
        } else {
          if (
            CustomFormat.parseFormatedDateTimeToInt(solicitacao.dataCriacao) >
            CustomFormat.parseFormatedDateTimeToInt(recente)
          ) {
            recente = solicitacao.dataCriacao;
          }
        }
      });
      return recente;
    },
    getSolicitacoesDoStatus: function(idStatus) {
      const self = this;
      if (idStatus && self.solicitacao.mapas.agrupamento) {
        if (self.status.mapas.statusCliente) {
          return self.solicitacao.mapas.agrupamento.get(self.status.mapas.statusCliente.get(idStatus));
        } else {
          return self.solicitacao.mapas.agrupamento.get(idStatus);
        }
      }
      return [];
    },
    getPermissao: function(requerida) {
      const self = this;
      if (requerida) {
        if (self.mapaPermissoes) {
          return self.mapaPermissoes.get(requerida);
        }
      }
      return false;
    },
    filtroFunctions: function() {
      const self = this;
      return {
        aplicarFiltros: function() {
          if (self.solicitacao.listas.original != null) {
            self.solicitacao.listas.filtrada = filtroHelper.filtrarPorPesquisa(
              self.solicitacao.listas.original,
              self.filtro.pesquisa.conteudo
            );
            if (self.getPermissao('ANALISA_SOLICITACAO')) {
              self.solicitacao.listas.filtrada = filtroHelper.filtrarPorContaSeguro(
                self.solicitacao.listas.filtrada,
                self.filtro.contas.selecionada
              );
              self.solicitacao.listas.filtrada = filtroHelper.filtrarPortipoSolicitacao(
                self.solicitacao.listas.filtrada,
                self.filtro.tipoSolicitacao.selecionado
              );
              self.solicitacao.listas.filtrada = filtroHelper.filtrarPorPremioSeguro(
                self.solicitacao.listas.filtrada,
                self.filtro.valorPremio.aplicado.valorMin,
                self.filtro.valorPremio.aplicado.valorMax
              );
            }
            if (self.filtro.data.aplicado.dataInicio != null) {
              self.solicitacao.listas.filtrada = filtroHelper.filtrarPorDataInicial(
                self.solicitacao.listas.filtrada,
                self.filtro.data.aplicado.dataInicio
              );
            }
            if (self.filtro.data.aplicado.dataFim != null) {
              self.solicitacao.listas.filtrada = filtroHelper.filtrarPorDataFinal(
                self.solicitacao.listas.filtrada,
                self.filtro.data.aplicado.dataFim
              );
            }
          }
        },
        aplicarDatas: function() {
          self.filtro.data.aplicado.dataInicio = self.filtro.data.dataInicio;
          self.filtro.data.aplicado.dataFim = self.filtro.data.dataFim;
          self.filtro.data.opened = false;
          this.aplicarFiltros();
          self.agruparSolicitacoes();
        },
        limparDatas: function() {
          self.filtro.data.aplicado.dataInicio = null;
          self.filtro.data.aplicado.dataFim = null;
          self.filtro.data.dataInicio = null;
          self.filtro.data.dataFim = null;
          self.filtro.data.opened = false;
          this.aplicarFiltros();
          self.agruparSolicitacoes();
        },
        selecionarConta: function(contaSelecionada) {
          self.filtro.contas.selecionada = contaSelecionada;
          self.filtro.contas.opened = false;
          this.aplicarFiltros();
          self.agruparSolicitacoes();
        },
        selecionartipoSolicitacao: function(tipoSolicitacaoSelecionado) {
          self.filtro.tipoSolicitacao.selecionado = tipoSolicitacaoSelecionado;
          self.filtro.tipoSolicitacao.opened = false;
          this.aplicarFiltros();
          self.agruparSolicitacoes();
        },
        aplicarValorPremio: function() {
          self.filtro.valorPremio.aplicado.valorMin = CustomFormat.removeMoneyFormat(self.filtro.valorPremio.valorMin);
          self.filtro.valorPremio.aplicado.valorMax = CustomFormat.removeMoneyFormat(self.filtro.valorPremio.valorMax);
          self.filtro.valorPremio.aplicado.formatado.valorMin = self.filtro.valorPremio.valorMin;
          self.filtro.valorPremio.aplicado.formatado.valorMax = self.filtro.valorPremio.valorMax;
          self.filtro.valorPremio.opened = false;
          this.aplicarFiltros();
          self.agruparSolicitacoes();
        },
        limparValorPremio: function() {
          self.filtro.valorPremio.aplicado.valorMin = null;
          self.filtro.valorPremio.aplicado.valorMax = null;
          self.filtro.valorPremio.aplicado.formatado.valorMin = null;
          self.filtro.valorPremio.aplicado.formatado.valorMax = null;
          self.filtro.valorPremio.valorMin = null;
          self.filtro.valorPremio.valorMax = null;
          self.$refs.filtroPremioValorMin.$el.getElementsByTagName('input')[0].value = 0;
          self.$refs.filtroPremioValorMax.$el.getElementsByTagName('input')[0].value = 0;
          self.filtro.valorPremio.opened = false;
          this.aplicarFiltros();
          self.agruparSolicitacoes();
        },
        abrirFiltroPesquisa: function() {
          self.filtro.pesquisa.opened = true;
        },
        fecharFiltroPesquisa: function() {
          if (!self.filtro.pesquisa.conteudo || self.filtro.pesquisa.conteudo == '') {
            self.filtro.pesquisa.opened = false;
          }
        }
      }
    }
  }
};
</script>

<style>
@import "../../../css/estilos.css";
.flex-custom {
  display: flex;
}
.icone-notificao-pendente {
  position: relative;
}
.icone-notificao-pendente::after {
  position: absolute;
  width: 11px;
  content: "";
  height: 11px;
  border-radius: 50%;
  background-color: white;
  top: 0px;
  right: 10px;
}
.icone-notificao-pendente::before {
  position: absolute;
  width: 6px;
  content: "";
  height: 6px;
  border-radius: 50%;
  background-color: #336A8B;
  top: 3px;
  right: 13px;
  z-index: 2;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/listagem-solicitacoes/ListagemSolicitacoes.vue